import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Rectangle,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  PieChart,
  Pie,
} from "recharts";
import React from "react";

const ChartContainer = ({ chartsData }) => {
  return (
    <div className="charts-container my-2">
      <div className="charts-title">
        <h2>Estadisticas Citas Agendadas</h2>
      </div>
      <div className="chart-section chart-bars row">
        <div className="chart-item col-12 col-lg-5">
          <div className="chart-title">
            <h4>Citas Por dia</h4>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              width={500}
              height={300}
              data={chartsData.weekday_count}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="x" height={50} angle={-45} textAnchor="end" />
              <YAxis />
              <Tooltip />
              <Bar
                dataKey="y"
                name="Cantidad"
                fill="#1F7EE8"
                activeBar={<Rectangle fill="#1F7EE8" stroke="#4CAF50" />}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="chart-item col-12 col-lg-5">
          <div className="chart-title">
            <h4>Citas Por hora</h4>
          </div>

          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              width={500}
              height={300}
              data={chartsData.hour_count}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="x" height={50} angle={-45} textAnchor="end" />
              <YAxis />
              <Tooltip />
              <Bar
                dataKey="y"
                name="Cantidad"
                fill="#1F7EE8"
                activeBar={<Rectangle fill="#1F7EE8" stroke="#4CAF50" />}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="chart-section chart-pies row">
        <div className="chart-item col-12 col-lg-5 d-flex flex-column justify-content-center">
          <div className="chart-title">
            <h4>Servicios</h4>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              width={500}
              height={300}
              data={chartsData.service_count}
              layout="vertical"
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" />
              <YAxis
                type="category"
                dataKey="l"
                width={100}
                // angle={22.5}
                textAnchor="end"
              />
              <Tooltip />
              <Bar
                dataKey="y"
                name="Cantidad"
                fill="#1F7EE8"
                activeBar={<Rectangle fill="#1F7EE8" stroke="#4CAF50" />}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="chart-item col-12 col-lg-5 d-flex flex-column justify-content-between">
          <div className="chart-title">
            <h4>Estado Asistencias</h4>
          </div>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart width={400} height={400}>
              <Pie
                dataKey="value"
                data={chartsData.summary_quotes}
                cx="50%"
                cy="50%"
                outerRadius={80}
                label={({ name, value }) => `${name}: ${value}`}
              />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default ChartContainer;
